import React, { useLayoutEffect, useRef, useState, useEffect } from "react";
import { Toast } from "primereact/toast";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import {
  DataTable,
  Column,
  Dropdown,
  InputText,
  InputSwitch,
  MultiSelect,
  iconSet,
  IcomoonReact,
  Sidebar,
} from "../PrimeReact.js";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import dashboardService from "../../services/dashboard-service";
import GV from "../../services/globalVar.js";
import { Space, Table, Tag, Menu, Flex } from "antd";

const Ticket = () => {
  const ds = new dashboardService();

  const toast = useRef(null);
  const [passDrawer, setPassDrawer] = useState(false);
  const [tdataLoad, setTdataLoad] = useState(false);
  const [gridList, setGridList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
 const [sizePerPage, setSizePerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [sortName, setSortName] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [searchVal, setSearchVal] = useState("");
  const [first1, setFirst1] = useState(0);
  const handleClosePass = () => {
    setPassDrawer(false);
  };

  const defaultValues = {
    ticketsummary: "",
    issue: "",
  };

  const {
    formState: { errors: errors },
    register: register,
    control: control,
    handleSubmit: handleSubmit,
    reset: reset,
    setValue,
  } = useForm({ mode: "onChange", defaultValues });


  const onCustomPage1 = (event) => {
    setFirst1(event.first);
    const val = event.page + 1;
    const size = event.rows;
    setSizePerPage(size);
    setPage(val);
    ticketGrid();

  };

  const onSort = (event) => {
    setLazyParams(event);
  };
    const [lazyParams, setLazyParams] = useState({
      first: first1,
      rows: sizePerPage,
      page: page,
      sortField: sortName,
      sortOrder: sortOrder,
    });
  const ticketGrid = () => {
    setTdataLoad(true);
    const datas = {
      Email: GV.userDet.appUser.appuserName,
      ProductName: GV.userDet.appUser.prodName,
    };
    ds.TicketsList(datas).then((res) => {
      setTdataLoad(false);
      setGridList(res.data.data);
      setTotalRecords(res.data.data.length)
    });
  };

  const onSubmit = (data) => {
    setTdataLoad(true);
    const datas = {
      message: data.issue,
      actAsType: "Customer",
      actAsEmail: GV.userDet.appUser.appuserName,
      name: GV.userDet.appUser.userName,
      subject: `${GV.userDet.appUser.prodName} | ${data.ticketsummary}`,
      from: GV.userDet.appUser.appuserName,
    };
    ds.RiseTicket(datas).then((res) => {
      setTdataLoad(false);
      toast.current.show({
        severity: "success",
        summary: res.data.data.message,
      });
      setPassDrawer(false);
      reset();
      ticketGrid();
    });
  };

  const onCancel = () => {
    setPassDrawer(false);
    reset();
  };

  const renderStatusColumn = (rowData) => {
    let status = rowData.status?.code.toUpperCase();
    let statusClass;
    switch (status) {
      case "OPEN":
        statusClass = "orange";
        break;

      case "CLOSED":
        statusClass = "green";
        break;

      default:
        statusClass = "cyan";
    }
    return (
      <Tag bordered={false} color={statusClass}>
        {status}
      </Tag>
    );
  };

  const renderPriorityColumn = (rowData) => {
    let status = rowData.priority?.code.toUpperCase();
    let statusClass;
    switch (status) {
      case "LOW":
        statusClass = "green";
        break;

      case "HIGH":
        statusClass = "red";
        break;

      default:
        statusClass = "cyan";
    }
    return (
      <Tag bordered={false} color={statusClass}>
        {status}
      </Tag>
    );
  };

  const renderHeader1 = () => {
    return (
      <div className="custom-sidebar-header d-flex py-2">
        <h4>New Ticket</h4>
        <button
          onClick={handleClosePass}
          className="p-sidebar-close p-link ms-auto"
        >
          <span className="pi pi-times" />
        </button>
      </div>
    );
  };

  useEffect(() => {
    ticketGrid();
  }, []);

  return (
    <div>
      <Toast ref={toast} />

      <div className="row mx-auto">
        <div className="col-md-12 p-0">
          <div className="card card-borderless cc-greyCard-custm mb-3">
            <div className="ms-2 my-2 me-2">
              <div className="d-flex justify-content-between align-items-center flex-wrap mx-2">
                <h4 className="m-0">Support List</h4>
                <div className=" d-flex justify-content-end flex-wrap text-t-primary kk-table-header kk-header-sec">
                  <div className="col">
                    <button
                      className="btn btn-primary py-1 me-2 my-2"
                      onClick={() => {
                        setPassDrawer(true);
                        reset();
                      }}
                    >
                      {" "}
                      <i className="pi pi-plus"></i> New Ticket
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white shadow-sm chart-of-account h-100 cc-greyCard-custm1">
            <div className="row coa-header kk-header-sec">
              <div className="col-auto header-right ms-auto"></div>
            </div>
            <div className="account-table">
              <DataTable
                stripedRows
                // className=" chofacc cc-greyCard-custm1"
                value={gridList}
                // header={header}
                // responsiveLayout="scroll"
                size="small"
                loading={tdataLoad}
                paginator
                lazy
                totalRecords={totalRecords}
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                rowsPerPageOptions={[10, 20, 50, totalRecords]}
                first={first1}
                rows={sizePerPage}
                onPage={onCustomPage1}
                onSort={onSort}
                sortField={lazyParams.sortField}
                sortOrder={lazyParams.sortOrder}
              >
                <Column field="id" header="Ticket ID" />

                {/* Subject */}
                <Column field="subject" header="Subject" />

                {/* Requester Name */}
                <Column field="customer.name" header="Requester Name" />

                {/* Priority with Conditional Background Color */}
                <Column
                  header="Priority"
                  body={(e) => renderPriorityColumn(e)}
                />

                <Column header="Status" body={(e) => renderStatusColumn(e)} />
              </DataTable>
            </div>
          </div>
        </div>
      </div>

      <Sidebar
        visible={passDrawer}
        position="right"
        className="security-drawer"
        onHide={handleClosePass}
      >
        <div slot="header">{renderHeader1()}</div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="py-3 rounded mt-4">
            <div className="row mx-0 mb-3">
              <div className="form-group col">
                <label className="ps-0 required">Ticket Summary</label>
                <div className="input-group">
                  <input
                    name="ticketsummary"
                    className="form-control"
                    // onInput={(e) => checkPassStrength(e)}
                    {...register("ticketsummary", { required: true })}
                  />
                </div>
                {errors.ticketsummary && (
                  <p className="text-danger">This field is required</p>
                )}
              </div>
            </div>
            <div className="row mx-0 mb-3">
              <div className="form-group col">
                <label className="ps-0 required">Request / Issue Details</label>
                <div className="input-group">
                  <input
                    name="issue"
                    className="form-control"
                    {...register("issue", { required: true })}
                    // onInput={(e) => checkBothPass(e)}
                  />
                </div>
                {errors.issue && (
                  <p className="text-danger">This field is required</p>
                )}
              </div>
            </div>
          </div>
          <div className="text-end mt-3">
            <Button
              label="Cancel"
              type="button"
              onClick={handleClosePass}
              className="p-button-text btn-cancel ms-auto btn btn-danger me-1"
            />
            <Button
              type="submit"
              label="Create Ticket"
              className="btn btn-primary"
            />
          </div>
        </form>
      </Sidebar>
    </div>
  );
};

export default Ticket;
